export type BREAKPOINT_CONFIG_TYPE = {
  [key: string]: {
    breakpoints: {
      [key: string]: number;
    };
    values: {
      [key: string]: number;
    };
  };
};

// Define breakpoint configurations for different components
export const BREAKPOINT_CONFIG = {
  meetingSlideRoll: {
    breakpoints: {
      sm: (754 * 1.3), // Reserve minimum ~25% screen space for Content
      md: (1120 * 1.3),
    },
    values: {
      sm: 388,
      md: 754,
      lg: 1120,
    },
  },
  responsivePadding: {
    breakpoints: {
      sm: 600,
      md: 1024,
    },
    values: {
      sm: 48,
      md: 48,
      lg: 32,
    },
  },
  // Add more component configurations here as needed
} satisfies BREAKPOINT_CONFIG_TYPE;

export type BreakpointConfigs = keyof typeof BREAKPOINT_CONFIG
